import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-upgrade-modal',
    templateUrl: './upgrade-modal.component.html',
    styleUrls: ['./upgrade-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpgradeModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<UpgradeModalComponent>,
    public sanitizer: DomSanitizer,
  ) { }
  
  ngOnInit(): void {
  }
  
  close(){
    this.matDialogRef.close(); 
  }
}